import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable, runInAction} from 'mobx';
import {getId, getUserAvatar, setUserAvatar} from '../../../utils/userUtility';
import {uploadToS3} from '../../../utils/awsUtility';
import UploadImageDialog from './UploadImageDialog';
import {DialogTypes} from '../../../constants/enums';

@inject('dialogStore', 'mainStore')
@observer
class ChangeUserAvatarContainer extends Component {
    @observable isLoading = false;

    @action changeUserAvatar = async (file) => {
        const {dialogStore, mainStore} = this.props;
        const id = `${getId()}_${Date.now()}`;
        mainStore.showProgressLoader();
        this.isLoading = true;
        await uploadToS3(file, id, file.type, null, 'musico-public-bucket/avatar', true);
        setUserAvatar(`/avatar/${id}`);
        runInAction(() => {
            this.isLoading = false;
        });
        dialogStore.closeDialog(DialogTypes.ProfilePhotoEditor);
        mainStore.hideProgressLoader();
    };

    render() {
        const {closeDialog, getDialogState} = this.props.dialogStore;

        return (<UploadImageDialog
            avatar={getUserAvatar()}
            open={getDialogState(DialogTypes.ProfilePhotoEditor)}
            title={'modalTitle'}
            onSave={this.changeUserAvatar}
            onRequestClose={() => closeDialog(DialogTypes.ProfilePhotoEditor)}
            isLoading={this.isLoading} />);
    }
}

export default ChangeUserAvatarContainer;
